<template>
  <div>
    <ml-header title="设置" :dark="true" />
    <div class="setting-container">
      <ul>
        <li @click="clearCache">
          <p>清理缓存</p>
          <img class="right" src="../../assets/personal/right@2x.png" alt="" />
        </li>
        <li @click="$router.push({ name: 'userProtocol' })">
          <p>用户协议</p>
          <img class="right" src="../../assets/personal/right@2x.png" alt="" />
        </li>
        <li @click="$router.push({ name: 'about' })">
          <p>关于</p>
          <img class="right" src="../../assets/personal/right@2x.png" alt="" />
        </li>
      </ul>
      <div class="logout">
        <ml-button
          background-color="rgba(230,230,230,1)"
          border-color="rgba(230,230,230,1)"
          width="100%"
          @click="handleLogout"
          >注销</ml-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Setting",
  computed: {
    ...mapState
  },
  methods: {
    ...mapActions("user", ["logout"]),
    clearCache() {
      this.$toast("缓存已清理");
    },
    handleLogout() {
      this.logout();
      this.$router.push({ name: "personal" });
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-container {
  padding: 40px 0 0 0;
  ul {
    padding-left: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 56px;
      line-height: 56px;
      border-bottom: 1px solid rgba(242, 242, 242, 1);
      p {
        line-height: 22px;
      }
      .right {
        margin-right: 19px;
        width: 9px;
        height: 15px;
        line-height: 56px;
      }
    }
  }
  .logout {
    padding: 50px 15px 0 15px;
  }
}
</style>
